/* eslint-disable */
import { AuthContext } from "contexts/authContext";
import { AuthStatus, IAuth } from "interfaces/IAuth";
import React from "react";
import { Route } from "react-router-dom";
import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import EmptyState from "components/EmptyState/EmptyState";

function ProtectedRoute({ component: Component, ...restOfProps }: any) {
  const { authStatus }: IAuth = React.useContext(AuthContext);
  const currentClinician = useAppSelector(selectCurrentClinician);

  if (authStatus !== AuthStatus.SignedIn) {
    return null;
  }

  if (restOfProps.paid && !currentClinician?.subscription?.subscribed) {
    return (
      <EmptyState
        icon="🔒"
        title="Premium Feature Required"
        description="This feature is only available with a paid subscription. Upgrade your plan to access advanced analytics, unlimited athletes, and premium tools."
        primaryAction={{
          label: "Upgrade Plan",
          to: "/user-profile?tab=3",
        }}
        secondaryAction={{
          label: "Go to Dashboard",
          to: "/",
        }}
        fullScreen={true}
      />
    );
  }

  return <Route {...restOfProps} component={Component} />;
}

export default ProtectedRoute;
